import { Autocomplete } from '@react-google-maps/api'
import { TextField } from '@mui/material'
import { useRef } from 'react'

type Props = {
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void

  addressField?: string
  cityField?: string
  countryField?: string
  latField?: string
  lngField?: string
  label?: string
}

export const AddressAutocomplete = ({
  value,
  onChange,
  setFieldValue,
  addressField,
  cityField,
  countryField,
  latField,
  lngField,
}: Props) => {
  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null)

  const onLoad = (autocomplete: google.maps.places.Autocomplete) => {
    autocompleteRef.current = autocomplete
  }

  const onPlaceChanged = () => {
    const place = autocompleteRef.current?.getPlace()
    if (!place || !place.geometry) return

    const address = place.formatted_address || ''
    const lat = place.geometry.location?.lat()
    const lng = place.geometry.location?.lng()
    const components = place.address_components || []

    const city = components.find((c) =>
      c.types.includes('administrative_area_level_1')
    )?.long_name
    const country = components.find((c) =>
      c.types.includes('country')
    )?.short_name

    setFieldValue(addressField ?? '', address ?? '')
    setFieldValue(cityField ?? '', city ?? '')
    setFieldValue(countryField ?? '', country ?? '')
    setFieldValue(latField ?? '', lat)
    setFieldValue(lngField ?? '', lng)
  }

  return (
    <Autocomplete
      onLoad={onLoad}
      onPlaceChanged={onPlaceChanged}
      options={{
        types: ['geocode'],
        fields: ['formatted_address', 'geometry', 'address_components'],
      }}
    >
      <TextField
        fullWidth
        autoComplete="off"
        value={value}
        onChange={onChange}
      />
    </Autocomplete>
  )
}
